// The site guide's session lives outside React: every route mounts its own layout, so the guide
// component remounts on navigation while a tour, its narration and the chat must carry on.

const SESSION_KEY = 'ew_guide_session';
const MAX_MESSAGES = 40;

const EMPTY = {
  userKey: null,
  open: false,
  messages: [],
  options: [],
  guide: null,
  conversationId: '',
  sending: false,
  listening: false,
};

const load = () => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null');
    return saved && typeof saved === 'object' ? { ...EMPTY, ...saved, sending: false, listening: false } : { ...EMPTY };
  } catch {
    return { ...EMPTY };
  }
};

let state = load();
let nextId = state.messages.reduce((max, m) => Math.max(max, m.id || 0), 0) + 1;
const listeners = new Set();

const persist = () => {
  try {
    const { sending, listening, ...keep } = state;
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(keep));
  } catch {
    /* private mode */
  }
};

export const getGuideSession = () => state;

export const subscribeGuideSession = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setGuideSession = (patch) => {
  const changes = typeof patch === 'function' ? patch(state) : patch;
  state = { ...state, ...changes };
  persist();
  listeners.forEach((listener) => listener());
};

export const addGuideMessage = (from, text) => {
  if (!text) return;
  setGuideSession((s) => ({ messages: [...s.messages, { id: nextId++, from, text }].slice(-MAX_MESSAGES) }));
};

// A different signed-in user (or signing out) starts a fresh session.
export const resetGuideSession = (userKey) => {
  state = { ...EMPTY, userKey };
  persist();
  listeners.forEach((listener) => listener());
};
